const initialState = {
    list: [

    ]
}

export default function chat(state = initialState, action) {
    switch(action.type) {
        case 'SET_USERS':
            return {
                ...state,
                list: action.payload
            }
        default:
            return state    
    }
}